import { Component, input } from '@angular/core';
import { SpinnerComponent, spinnerSize } from '@sb/ui/spinner';

@Component({
  selector: 'stat-summary-value',
  imports: [SpinnerComponent],
  template: `
    @if (loading()) {
      <sb-spinner [size]="spinnerSize()" />
    } @else {
      <ng-content />
    }
  `,
  host: {
    class: 'flex items-center justify-center text-3xl text-default',
  },
})
export class StatSummaryValueComponent {
  loading = input(false);
  spinnerSize = input<spinnerSize>('md');
}
